// Item
import { READ_ITEM } from "@modules/inventory/item/item/constants";
import { READ_CONTACT } from "@modules/website/support/contact/constants";
import { READ_ORDER } from "@modules/website/e-commerce/order/constants";
import { READ_REWARD_REDEMPTION } from "@modules/website/e-commerce/reward-redemption/constants";
import { READ_SYNCHRONIZE } from "src/modules/website/store-front/synchronize/constants";
import { READ_LICENSE_KEY } from "@modules/website/kaspersky/license-key/constants";

export default {
  sideBarTitle: "Website",
  hasDashboard: true,
  isFixed: false,
  slug: "website",
  display: true,
  menus: [
    {
      id: 1,
      title: "E-Commerce",
      slug: "e-commerce",
      icon: "ShoppingCartOutlined",
      sub: [
        {
          id: 1,
          title: "Cart",
          slug: "cart",
          code: READ_ORDER
        },
        {
          id: 2,
          title: "Order",
          slug: "order",
          code: READ_ORDER
        },
        {
          id: 2,
          title: "Item Reward",
          slug: "item-reward",
          code: READ_ORDER
        },
        {
          id: 3,
          title: "Reward Redemption",
          slug: "reward-redemption",
          code: READ_REWARD_REDEMPTION
        }
      ]
    },
    {
      id: 2,
      title: "Store Font",
      slug: "store-front",
      icon: "PictureOutlined",
      sub: [
        {
          id: 1,
          title: "Item Catalog",
          slug: "item-catalog",
          code: READ_ITEM
        },
        {
          id: 2,
          title: "Banner List",
          slug: "banner-list",
          code: READ_ITEM
        },
        {
          id: 3,
          title: "Synchronization",
          slug: "synchronization",
          code: READ_SYNCHRONIZE
        }
      ]
    },
    {
      id: 3,
      title: "Support",
      slug: "support",
      icon: "ContactsOutlined",
      sub: [
        {
          id: 1,
          title: "Contact",
          slug: "contact",
          code: READ_CONTACT
        }
      ]
    },
    { 
      id: 4,
      title: "Kaspersky",
      slug: "kaspersky",
      icon: "KeyOutlined",
      code: READ_LICENSE_KEY,
      sub: [
        {
          id: 1,
          title: "License Key",
          slug: "license-key",
          code: READ_LICENSE_KEY
        }
      ]
    }
  ]
};

